export default __webpack_public_path__ + "static/media/shopeepay_url_dependencies.e41212ff.txt";